import { useMemo, useState } from 'react';
import { Form } from 'react-bootstrap';
import { AdminBrandListItem } from '@blisspointmedia/bpm-types/dist/GoogleAdsAudit';
import { InteractiveDiv } from '@Components/InteractiveEl';

interface AdminBrandsListProps {
  brands: AdminBrandListItem[];
  onOpenBrand: (id: string) => void;
}

export const AdminBrandsList = ({ brands, onOpenBrand }: AdminBrandsListProps) => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return brands;
    return brands.filter(b => b.displayName.toLowerCase().includes(q) || b.accountId.includes(q));
  }, [brands, search]);

  return (
    <div className='google-ads-audit-admin-brands-list'>
      <Form.Control
        placeholder='Search by name or account ID'
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      {filtered.map(brand => (
        <InteractiveDiv
          key={brand.id}
          className='google-ads-audit-account-row'
          onClick={() => onOpenBrand(brand.id)}
        >
          <span className='google-ads-audit-account-name'>{brand.displayName}</span>
          <span className='google-ads-audit-account-id'>{brand.accountId}</span>
          <span className='google-ads-audit-account-id'>{brand.businessModel ?? '—'}</span>
          <span className='google-ads-audit-account-id'>{brand.completeness}% complete</span>
        </InteractiveDiv>
      ))}
    </div>
  );
};
